import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Pagination from "react-js-pagination";
import DownloadCSV from "../../utils/DownloadCSV";

const TableComponent = ({ title = "", data, columns, itemsPerPage = 20 }) => {
    const [filteredData, setFilteredData] = useState(data);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");

    // Filter data based on search term
    useEffect(() => {
        const filtered = data.filter((item) =>
            Object.values(item).some(
                (value) =>
                    value &&
                    value.toString().toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
        setFilteredData(filtered);
        setCurrentPage(1); // Reset to first page on search
    }, [data, searchTerm]);

    // Pagination logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };

    return (
        <div className="card">
            <div className="card-header row">
                <div className="col-md-6">
                    <h5 className="card-title text-left">{title}</h5>
                </div>
                <div className="col-md-4">
                    <input
                        type="search"
                        className="form-control"
                        placeholder="Search"
                        value={searchTerm}
                        onChange={handleSearch}
                    />
                </div>
                <div className="col-md-2 text-right">
                    <DownloadCSV data={filteredData} fileName={title} />
                </div>
            </div>
            <div className="card-body table-responsive">

                {/* Table */}
                <table className="table table-striped table-hover">
                    <thead>
                        <tr>
                            {columns.map((column, index) => (
                                <th key={index} scope="col">
                                    {column.header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {currentItems.length > 0 ? (
                            currentItems.map((item, index) => (
                                <tr key={item.id || index}>
                                    {columns.map((column, colIndex) => (
                                        <td key={colIndex}>
                                            {typeof column.accessor === "function"
                                                ? column.accessor(item, index)
                                                : item[column.accessor]}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={columns.length} className="text-center">
                                    No data found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

                {/* Pagination */}
                <Pagination
                    activePage={currentPage}
                    itemsCountPerPage={itemsPerPage}
                    totalItemsCount={filteredData.length}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                />
            </div>
        </div>
    );
};

TableComponent.propTypes = {
    data: PropTypes.array.isRequired,
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            header: PropTypes.string.isRequired,
            accessor: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
                .isRequired,
        })
    ).isRequired,
    itemsPerPage: PropTypes.number,
};

export default TableComponent;



// WEBPACK FOOTER //
// ./src/component/admin/TableComponent.js